<template>
  <ak-card-header>
    <h4 class="color-grey">Select a widget</h4>
  </ak-card-header>
  <ak-card-body :size="'flush'" class="p-small flex--column scrollable">
    <div class="flex flex--grid pt-small">
      <template v-for="(widget, name) in widgets" :key="name">
        <div
          v-if="
            !widget.hide &&
            display('hide', widget.restrict) &&
            enabled(widget.component) &&
            widget.name !== 'leadsContacts'
          "
          :class="size === 'large' ? 'one-third' : 'one-half'"
        >
          <ak-box
            bordered
            rounded
            class="one-whole flex flex--center p-small is-selectable"
            :value="widget.entityName"
            @click="changeWidget(widget.name)"
          >
            <div class="text-center one-whole">
              <ak-icon
                size="large"
                :type="getIcon(widget.icon)"
                class="color-grey-light mb-tiny"
              />
              <h5 class="color-grey mb-none">{{ widget.entityName }}</h5>
            </div>
          </ak-box>
        </div>
      </template>
    </div>
  </ak-card-body>
</template>

<script>
import { defineComponent } from 'vue'
import CardHeader from '@akerolabs/akero-vue/src/components/cards/CardHeader.vue'
import CardBody from '@akerolabs/akero-vue/src/components/cards/CardBody.vue'
import Box from '@akerolabs/akero-vue/src/components/box/Box.vue'
import Icon from '@akerolabs/akero-vue/src/components/icon/Icon.vue'
import { display } from '@akerolabs/akero-vue/src/services/users'

export default defineComponent({
  name: 'AkWidgetSelect',
  components: {
    [CardHeader.name]: CardHeader,
    [CardBody.name]: CardBody,
    [Box.name]: Box,
    [Icon.name]: Icon,
  },
  inheritAttrs: false,
  props: {
    /**
     * @type {Array}
     * @description The widgets
     */
    widgets: {
      type: Array,
      default: () => [],
    },
    /**
     * @type {Function}
     * @description Update the widget state
     */
    changeWidget: {
      type: Function,
      default: () => ({}),
    },
    /**
     * @type {String}
     * @description Check size of widget
     */
    size: {
      type: String,
      default: undefined,
    },
    /**
     * @type {Function}
     * @description Checks if features are enabled
     */
    enabled: {
      type: Function,
      default: () => ({}),
    },
  },
  setup() {
    const getIcon = (icon) => {
      return icon.split('icon-').join('')
    }
    return {
      getIcon,
      display,
    }
  },
})
</script>
